import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import * as api from 'helpers/api';
import { Form, Modal, ProgressBar } from 'react-bootstrap-5';

export class DuplicationForm extends React.Component {
  static propTypes = {
    assignment: PropTypes.bool,
    features: PropTypes.shape({
      projectAttachments: PropTypes.bool
    }).isRequired,
    projectId: PropTypes.number.isRequired,
    projectTitle: PropTypes.string.isRequired,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired
  }

  state = {
    attachments: this.props.features.projectAttachments,
    docs: true,
    duplicating: false,
    duplicationId: null,
    duplicationStatus: null,
    newPropertyUrl: null,
    photos: true,
    proposal: false,
    percentComplete: 0,
    statusUrl: null
  }

  pollDuplicationStatus = (statusUrl = this.state.statusUrl) => {
    api.get(statusUrl).then((data) => {
      this.setState({
        percentComplete: data.percentComplete,
        duplicationStatus: data.status
      });

      if (data.percentComplete >= 100) {
        window.location = data.url;
        return;
      }

      setTimeout(() => this.pollDuplicationStatus(statusUrl), 1000);
    });
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.checked });
  }

  handleSubmit = () => {
    this.setState({ duplicating: true, duplicationStatus: "Preparing to duplicate" });
    const data = {
      propertyDuplication: {
        existingPropertyId: this.props.projectId,
        duplicateAttachments: this.state.attachments,
        duplicatePhotos: this.state.photos,
        duplicateDocs: this.state.docs,
        forceProposal: this.state.proposal
      }
    };
    api.post("/property_duplications", data).then((response) => {
      this.setState({ duplicationId: response.id, statusUrl: response.statusUrl });
      this.pollDuplicationStatus(response.statusUrl);
    });
  }

  renderCheckbox(label, key) {
    return (
      <Form.Check
        checked={this.state[key]}
        id={`${key}-toggle`}
        label={label}
        name={key}
        type="checkbox"
        onChange={this.handleInputChange}
      />
    );
  }

  renderStatus() {
    return (
      <div className="my-4">
        <div className="fs-large fw-semibold mb-1">{this.state.duplicationStatus}</div>
        <ProgressBar active now={this.state.percentComplete} />
      </div>
    );
  }

  renderModalBody() {
    if (this.state.duplicating) {
      return this.renderStatus();
    }
    return (
      <React.Fragment>
        {this.props.assignment ? (
          <div>
            <div className="mb-4">Client Details and Requirements will be duplicated.</div>
            <div className="mb-1 fw-semibold">Optional:</div>
            {this.renderCheckbox("Duplicate Attachments", "attachments")}
          </div>
        ) : (
          <div>
            {this.renderCheckbox("Duplicate Photos", "photos")}
            {this.renderCheckbox("Duplicate Docs", "docs")}
            {this.props.features.projectAttachments && this.renderCheckbox('Duplicate Attachments', 'attachments')}
            <hr/>
            {this.renderCheckbox("Create as a proposal?", "proposal")}
            <hr/>
          </div>
        )}
      </React.Fragment>
    );
  }

  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title>
            Duplicate “{this.props.projectTitle}”?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderModalBody()}
        </Modal.Body>
        {!this.state.duplicating && (
          <Modal.Footer>
            <input
              className="btn btn-primary"
              name="submit"
              type="submit"
              value={this.props.assignment ? 'Duplicate Assignment' : 'Duplicate Property'}
              onClick={this.handleSubmit}
            />
          </Modal.Footer>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  features: state.features
});

export default connect(mapStateToProps)(DuplicationForm);
